module.exports = __webpack_public_path__ + "static/media/title.1f692ea2.svg";